<template>
  <div>
    <v-select 
      ref="select"
      label="Empresa" 
      :readonly="readonly" 
      :items="companies" 
      v-model="selected_company" 
      :loading="loading"
      item-text="attributes.name" 
      :item-value="item_value"
      :rules="companyRules"
      :prepend-icon="without_icon || outlined ? '' : 'mdi-domain'"
      :prepend-inner-icon="outlined && !without_icon ? 'mdi-domain' : undefined"
      :outlined="outlined"
      :dense="dense"
      :hide-details="outlined ? 'auto' : undefined"
      :return-object="return_object"
      :clearable="false"
    ></v-select>
  </div>
</template>

<script>
import Api from '@/api/index'
import validations from '@/mixins/validations.js'

export default {
  name: 'SelectCompany',
  mixins: [ validations ],
  props:{
    company:{
      type: String
    },
    company_key: {
      type: String,
      default: null,
    },
    readonly:{
      type: Boolean,
      default: false,
    },
    only_with_credentials:{
      type: Boolean,
      default: false
    },
    without_icon: {
      type: Boolean,
      default: false
    },
    return_object: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      companies: [],  
      loading: false,
      selected_company: "",
      syncing_from_prop: false,
    }
  },
  computed: {
    item_value() {
      if (this.return_object) {
        return 'id'
      }
      if (this.company_key != null) {
        return 'attributes.gateway_key'
      }
      return 'attributes.name'
    },
    companyRules() {
      return [
        (v) => {
          if (!v) return 'Campo é necessário'

          if (typeof v === 'object') {
            const key = v.attributes?.gateway_key || v.gateway_key
            return !!String(key || '').trim() || 'Empresa sem gateway key'
          }

          return !!String(v).trim() || 'Campo é necessário'
        },
      ]
    }
  },
  methods: {
    getData() {
      this.getCompanies()
    },
    getCompanies(){
      this.loading = true
      let filter = { short: true }
      if(this.only_with_credentials){
        filter = {...filter, only_with_credentials: true}
      }
      Api.Company.index(filter).then(r => r.data).then(res => {
        this.companies = [...res.data]
        this.setSelectedCompanyByProp()
      }).finally(()=>{
        this.loading = false
      })
    },
    setSelectedCompanyByProp(){
      this.syncing_from_prop = true

      try {
        if (this.company_key) {
          const match = this.companies.find(
            (c) => c.attributes?.gateway_key === this.company_key
          )
          if (match) {
            this.selected_company = this.return_object ? match : match.attributes.gateway_key
          } else if (!this.companies.length) {
          } else if (!this.return_object) {
            this.selected_company = this.company_key
          }
          return
        }

        if (this.company_key === '') {
          this.selected_company = this.return_object ? null : ''
          return
        }

        if (this.return_object && this.company) {
          const match = this.companies.find(
            (c) => c.attributes?.name === this.company
          )
          if (match) this.selected_company = match
          return
        }

        this.selected_company = this.company
      } finally {
        this.$nextTick(() => {
          this.syncing_from_prop = false
        })
      }
    },
    validate() {
      const hasValue = !!this.selectedGatewayKey() || (!!this.selected_company && typeof this.selected_company === 'string' && this.selected_company.trim())
      if (this.return_object || this.company_key != null) {
        return !!this.selectedGatewayKey()
      }
      const selectOk = this.$refs.select?.validate?.(true) !== false
      return selectOk && hasValue
    },
    selectedGatewayKey() {
      const selected = this.selected_company
      if (!selected) return ''
      if (typeof selected === 'object') {
        return String(selected.attributes?.gateway_key || selected.gateway_key || '').trim()
      }
      return String(selected).trim()
    }
  },
  watch: {
    company(){
      this.setSelectedCompanyByProp()
    },
    company_key(){
      this.setSelectedCompanyByProp()
    },
    selected_company(nv){
      if (this.syncing_from_prop) return
      this.$emit("newCompany", nv)
    }
  },
  mounted(){
    this.getData()
  }
}
</script>
